import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map, of, shareReplay } from 'rxjs';
import { MetricDefinitionDto } from 'src/core/models/dashboard/metric-definition.dto';
import { MetricIds } from 'src/core/models/enum/metric-ids.enum';
import { AgentType } from 'src/core/models/enum/agent-type.enum';
import { resolveUrl, API_PREFIX } from 'src/core/constants/api.constants';

@Injectable({ providedIn: 'root' })
export class MetricDefinitionService {
  private readonly definitions$: Observable<MetricDefinitionDto[]>;
  private cachedDefinitions: MetricDefinitionDto[] = [];

  constructor(private http: HttpClient) {
    this.definitions$ = this.http
      .get<MetricDefinitionDto[]>(resolveUrl(`${API_PREFIX}/dashboard/metric-definitions`))
      .pipe(
        catchError(() => of([])),
        shareReplay({ bufferSize: 1, refCount: false }),
      );
    this.definitions$.subscribe(defs => {
      this.cachedDefinitions = defs;
    });
  }

  getDefinitions(): Observable<MetricDefinitionDto[]> {
    return this.definitions$;
  }

  getByMetricId(metricId: MetricIds): Observable<MetricDefinitionDto | undefined> {
    return this.definitions$.pipe(map(defs => defs.find(d => d.metricId === metricId)));
  }

  getSupportedTypesSync(metricId: MetricIds): AgentType[] {
    return this.cachedDefinitions.find(d => d.metricId === metricId)?.supportedAgentTypes ?? [];
  }
}
